// extracted by mini-css-extract-plugin
export var conversationView = "BevFE";
export var firstColumnNoTwistyWithHeaders = "DMjcl";
export var firstColumnWithHeaders = "mn28d";
export var itemView = "NV2gU";
export var senderImageOn = "WA2af";
export var standardizedFirstColumn = "mXLG_";
export var standardizedSecondColumn = "Gts_D";